import request from '@/utils/request'

export function indexData() {
  return request({
    url: '/api/index/index',
    method: 'get'
  })
}

export function articleView(data) {
  return request({
    url: '/api/index/article',
    method: 'get',
    params: data
  })
}

export function categoryView(data) {
  return request({
    url: '/api/index/category',
    method: 'get',
    params: data
  })
}

export function aboutData() {
  return request({
    url: '/api/index/about',
    method: 'get'
  })
}

export function articleList(data) {
  return request({
    url: '/api/index/articleLists',
    method: 'get',
    params: data
  })
}

export function licheng() {
  return request({
    url: '/api/index/licheng',
    method: 'get'
  })
}

export function customer(data) {
  return request({
    url: '/api/index/customer',
    method: 'get',
    params: data
  })
}

export function jobsConfig() {
  return request({
    url: '/api/index/jobsConfig',
    method: 'get'
  })
}

export function jobsList(data) {
  return request({
    url: '/api/index/jobsList',
    method: 'get',
    params: data
  })
}

export function jobInfo(data) {
  return request({
    url: '/api/index/jobInfo',
    method: 'get',
    params: data
  })
}

export function getConfig(data) {
  return request({
    url: '/api/index/getConfig',
    method: 'get'
  })
}

export function categoryLists(data) {
  return request({
    url: '/api/index/categoryLists',
    method: 'get',
    params: data
  })
}

export function uploadFile(data) {
  return request({
    url: '/api/common/upload',
    method: 'post',
    type:'multipart/form-data',
    data
  })
}

export function applys(data) {
  return request({
    url: '/api/index/applys',
    method: 'post',
    data
  })
}










// WEBPACK FOOTER //
// ./src/api/web.js